import React from "react"
import Head from "next/head"

import { Container, Card, Table } from "react-bootstrap"

function LandlordPriceList() {
    const url = "https://webbjenkins.co.uk/landlord-price-list/"
    const title = "Landlord Price List - Webb Jenkins"
    const description =
        "We try to make the costs for landlords as transparent as possible, do not hesitate to get in touch to clarify any misunderstandings."
    const imgUrl =
        "https://webb-jenkins-static-164679926.imgix.net/socials/webbjenkins-landlord-fees-social.jpg"
    const imgWidth = 1200
    const imgHeight = 630
    const imgAlt = "Webb Jenkins logo with landlord price list caption"
    return (
        <>
            <Head>
                <link rel="canonical" href={url} />
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta property="fb:app_id" content="362437448786240" />
                <meta property="og:title" content={title} />
                <meta property="og:image:url" content={imgUrl} />
                <meta property="og:image:width" content={imgWidth} />
                <meta property="og:image:height" content={imgHeight} />
                <meta property="og:image:alt" content={imgAlt} />
                <meta property="og:description" content={description} />
                <meta property="og:url" content={url} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_GB" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image:src" content={imgUrl} />
                <meta name="twitter:site" content="@WebbJenkinsIOW" />
            </Head>
            <Container fluid="md" as={Card} className="mt-5 mb-4">
                <Card.Body>
                    <Card.Title>
                        <h1 className="text-center">Landlord price list</h1>
                    </Card.Title>
                </Card.Body>
            </Container>
            <Container fluid="md" as={Card}>
                <Card.Body>
                    <p>Last updated: 25 October, 2024</p>
                    <h2>Rental services</h2>
                    <ul>
                        <li>
                            <p>
                                <b>Tenant find only</b> - one month&apos;s rent
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Full management</b> - 12%
                            </p>
                        </li>
                    </ul>
                    <h2 className="mt-5">Reference fees</h2>
                    <ul>
                        <li>
                            <p>
                                <b>Individual</b> - £100
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Couple</b> - £150
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Guarantor</b> - £50
                            </p>
                        </li>
                    </ul>

                    <h2 className="mt-5">Tenancy fees</h2>
                    <ul>
                        <li>
                            <p>
                                <b>
                                    Corgi registered gas safety certificate
                                    (required every year)
                                </b>{" "}
                                - £120
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Gas safety certificate and service</b> - £150
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>
                                    EICR (Electrical installation condition
                                    report)
                                </b>{" "}
                                - £216
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>EPC (Energy performance certificate)</b> -
                                £120
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>
                                    To draft and serve a Section 21 or Section 8
                                </b>{" "}
                                - £75
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>
                                    If the tenant doesn&apos;t vacate and a
                                    representation in court is required
                                </b>{" "}
                                - £150
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>
                                    To transfer management of a vacant property
                                </b>{" "}
                                - £125
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>
                                    To transfer management of a property with a
                                    tenant in situ
                                </b>{" "}
                                - £175
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Inventory fees</b> - Subject to the size of
                                the property and will be applied at the start
                                and end of a tenancy (see attached graph)
                            </p>
                        </li>
                    </ul>

                    <h2 className="mt-5">Inventory production prices</h2>
                    <Table responsive="md" striped border hover>
                        <thead>
                            <tr>
                                <th>No. of bedrooms</th>
                                <th>1</th>
                                <th>2</th>
                                <th>3</th>
                                <th>4</th>
                                <th>5</th>
                                <th>6+</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>Unfurnished initial inventory</th>
                                <td>£115</td>
                                <td>£135</td>
                                <td>£150</td>
                                <td>£185</td>
                                <td>£215</td>
                                <td>POA</td>
                            </tr>
                            <tr>
                                <th>Furnished initial inventory</th>
                                <td>£155</td>
                                <td>£180</td>
                                <td>£205</td>
                                <td>£235</td>
                                <td>£265</td>
                                <td>POA</td>
                            </tr>
                            <tr>
                                <th>Unfurnished inventory update</th>
                                <td>£85</td>
                                <td>£95</td>
                                <td>£105</td>
                                <td>£130</td>
                                <td>£175</td>
                                <td>POA</td>
                            </tr>
                            <tr>
                                <th>Furnished inventory update</th>
                                <td>£108</td>
                                <td>£132</td>
                                <td>£160</td>
                                <td>£190</td>
                                <td>£210</td>
                                <td>POA</td>
                            </tr>
                        </tbody>
                    </Table>

                    <h2 className="mt-5">Tenancy renewal fees</h2>
                    <ul>
                        <li>
                            <p>
                                <b>Renewal of 6 month lease</b> - £60
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Renewal of 12 month lease</b> - £72
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Renewal of 18 month (or longer) lease</b> -
                                £85
                            </p>
                        </li>
                    </ul>

                    <h2 className="mt-5">General fees</h2>
                    <ul>
                        <li>
                            <p>
                                <b>Valuation fee for insurance purposes</b> -
                                £120
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>
                                    Annual charge for overseas annual tax return
                                    and tax deduction certificates
                                </b>{" "}
                                - £90
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>
                                    Sale of property to tenant, or party
                                    connected with tenant upon completion of
                                    sale
                                </b>{" "}
                                - 1.25%
                            </p>
                        </li>
                    </ul>

                    <p className="mt-5">
                        If you have any questions regarding these fees, please
                        contact a member of staff on{" "}
                        <a href="tel:01983 856111" role="button">
                            <b>01983 856111</b>
                        </a>{" "}
                        or via email to <b>rentals@webbjenkins.co.uk</b>.
                    </p>
                </Card.Body>
            </Container>
        </>
    )
}

export default LandlordPriceList
